import path from "path";

import type { Options as HttpProxyOptions } from "http-proxy-middleware";

export type FarmProxyConfig = Pick<HttpProxyOptions, "changeOrigin" | "pathRewrite"> & { target: string };

export interface FarmConfig {
    engineDirectory?: string;
    resourcesDirectory?: string;
    proxy?: Record<string, FarmProxyConfig>;
}

export function readFarmConfig(farmDirectory: string): FarmConfig {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-require-imports
    const configEvaluationResult: any = require(path.join(farmDirectory, "config.js"))(farmDirectory);
    return {
        engineDirectory: configEvaluationResult.localEngineDirectoryPath,
        resourcesDirectory: configEvaluationResult.resourcesDirectoryPath,
        proxy: configEvaluationResult.proxy,
    };
}
